<template lang="pug">
  .page.about-us
    header.page__header.about-us__header.au-header
      .au-header__main-header
        main-header
      .au-header__img
        img(src="@/assets/images/about-us/about-us-header.jpg" alt="О нас")
    main.page__main
      .container
        section.au-content
          .au-content__title
            h1.title О нас
          .au-content__main
            .content
              .content__block(
              v-html="text"
              )
              .content__block
                .video
                  iframe(
                  width='560'
                  height='315'
                  src='https://www.youtube.com/embed/dE_c4bwpCQw'
                  frameborder='0'
                  allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                  allowfullscreen=''
                  )
    footer.page__footer
      main-footer

</template>

<script>
import MainHeader from "../../components/main-header/main-header";
import MainFooter from "../../components/main-footer/main-footer";
export default {
  name: "AboutUs",
  components: { MainFooter, MainHeader },
  data() {
    return {
      text:
        "<p>Государственное бюджетное учреждение «Республиканский центр по организации оздоровления, отдыха и занятости детей и подростков «Лето» курирует работу детских оздоровительных лагерей республики всех форм отдыха, осуществляет взаимодействие с заинтересованными министерствами и ведомствами, муниципалитетами, предприятиями и организациями, в управлении которых находятся оздоровительные организации.</p>" +
        "<strong><p>Основные направления работы Республиканского центра:</p></strong>" +
        "<ul>" +
        "<li><p>координация реализации Программы отдыха детей и молодежи Республики Татарстан;</p></li>" +
        "<li><p>ежегодное обновление реестра лагерей Республики Татарстан, участвующих в оздоровительной кампании, проведение мониторинга состояния материально-технической базы ДОЛ, проведение паспортизации детских оздоровительных учреждений РТ;</p></li>" +
        "<li><p>организация и проведение конкурсных процедур на приобретение путевок для детей и молодежи, заключение в порядке, определяемом законодательством, контрактов (договоров) на приобретение путевок в оздоровительные и санаторные учреждения, лагеря, расположенные на территории Российской Федерации;</p></li>" +
        "<li><p>сбор, анализ заявок, согласование, систематизация и утверждение программ профильных смен и палаточных лагерей, организация Смотра профильных программ по линии Министерства по делам молодежи РТ;</p></li>" +
        "<li><p>методическая и консультативная помощь организаторам отдыха и оздоровления детей и молодежи в течение всей оздоровительной кампании;</p></li>" +
        "<li><p>ежегодная организация и проведение Школы вожатых, семинаров для организаторов летнего отдыха, для начальников лагерей, бухгалтеров, членов межведомственных комиссий по организации отдыха детей и молодежи муниципальных образований РТ;</p></li>" +
        "<li><p>организация и проведение смотр-конкурса «Лучшая организация отдыха и оздоровления детей и молодёжи РТ», регионального этапа Всероссийского конкурса «Лучшая программа организации детского отдыха», а также - фестиваля палаточных лагерей «Звездный десант - новая волна»;</p></li>" +
        "</ul>",
    };
  },
};
</script>
